<div class="
    icon-wrapper">
  <svg>
    <circle cx="50"
      cy="50"
      r="50" />
    <path [attr.d]="ADD_NEW_PATH_1"></path>
    <path fill-rule="evenodd"
      clip-rule="evenodd"
      [attr.d]="ADD_NEW_PATH_2"></path>
  </svg>
</div>